import React from "react";
import { SubTitleRegular } from "../typography";
import "./style.scss";

interface CardProps {
    children?: React.ReactNode;
    footer?: React.ReactNode | string;
    showProgressBar?: boolean;
    title?: React.ReactNode | string;
    height?: string | number;
    width?: string | number;
    horizontal?: boolean;
    disabled?: boolean;
    style?: object;
}

const Card = (props: CardProps) => {
    const { children, footer, title } = props;
    return (
        <div
            className={
                !props.disabled
                    ? `vapor-card vapor-card-container ${props.horizontal ? "horizontal" : ""}`
                    : `vapor-card vapor-card-container ${props.horizontal ? "horizontal" : ""} disabled`
            }
            style={{ width: props.width, height: props.height, ...props.style }}
        >
            <div className="vapor-card-content">
                <SubTitleRegular
                    color={!props.disabled ? "darkImperialBlue" : "#c9d9e8"}
                >
                    {title}
                </SubTitleRegular>
                {children}
            </div>
            {/* showProgressBar && <ProgressBar completedSteps={2} totalSteps={4} completionPercentage={50} />*/}
            <div className="vapor-card-footer">{footer}</div>
        </div>
    );
};

Card.defaultProps = {
    showProgressBar: false,
    horizontal: false,
    style: {},
};

export default Card;
